import { AddressActions } from "src/Components/Common/addressmap";

export default function CustomerInformation({ customer }) {
  return (
    <div className="w-full pb-6 bg-white rounded-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] border border-[#E5E8F3] flex flex-col justify-start items-center gap-6 overflow-hidden">
      <div className="self-stretch px-6 py-4 bg-slate-50 border-b border-slate-200 flex flex-col justify-start items-start">
        <div className="self-stretch flex flex-col justify-start items-start">
          <div className="self-stretch justify-center capitalize text-[#1A2332] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px]">
            Customer Information
          </div>
        </div>
      </div>
      <div className="w-full flex justify-between items-start gap-4 px-[24px]">
        <div className="flex-1 min-w-0 self-stretch inline-flex flex-col justify-start items-start gap-1 bg-red">
          <div className="justify-center text-[#7C829A] font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] uppercase">
            Company
          </div>
          <div className="self-stretch flex flex-col justify-start items-start">
            <div className="self-stretch justify-center text-[#1A2332] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px] capitalize break-words">
              {customer.companyName || "—"}
            </div>
          </div>
        </div>
        <div className="flex-1 min-w-0 self-stretch inline-flex flex-col justify-start items-start gap-1">
          <div className="justify-center text-[#7C829A] font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] uppercase">
            Email
          </div>
          <div className="self-stretch flex flex-col justify-start items-start">
            <div className="self-stretch justify-center text-[#1A2332] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px] break-all">
              {customer.email || "—"}
            </div>
          </div>
        </div>
        <div className="flex-1 min-w-0 self-stretch inline-flex flex-col justify-start items-start gap-1">
          <div className="justify-center text-[#7C829A] font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] uppercase">
            Contact
          </div>
          <div className="self-stretch flex flex-col justify-start items-start">
            <div className="self-stretch justify-center text-[#1A2332] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px] capitalize break-words">
              {customer.contact || "—"}
            </div>
          </div>
        </div>
        <div className="flex-1 min-w-0 self-stretch inline-flex flex-col justify-start items-start gap-1">
          <div className="w-30 justify-center text-[#7C829A] font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] uppercase">
            Phone Number
          </div>
          <div className="self-stretch flex flex-col justify-start items-start">
            <div className="self-stretch justify-center text-[#1A2332] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px] break-words">
              {customer.phone || "—"}
            </div>
          </div>
        </div>
        <div className="flex-1 min-w-0 self-stretch inline-flex flex-col justify-start items-start gap-[2.88px]">
          <div className="justify-center text-[#7C829A] font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] uppercase">
            Address
          </div>
          <div className="self-stretch pb-[0.63px] flex flex-col justify-start items-start gap-1">
            <div className="self-stretch justify-center text-[#1A2332] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px] capitalize break-words">
              {customer.address || "—"}
            </div>
            <AddressActions address={customer.address} />
          </div>
        </div>
      </div>
    </div>
  );
}
